import React, { Fragment } from 'react'
import TopBanner from '../../Components/Main/TopBanner'
import AboutDetail from '../../Components/AboutUs/AboutDetail'
import Features from '../../Components/Home/Features'
import useAboutUs from '../../Hooks/WebPages/useAboutUs'

const AboutUs = () => {

    const {
        isLoading,
        aboutUsData,
        handleAboutUs
    } = useAboutUs()

    return (
        <Fragment>
            {
                aboutUsData && (
                    <TopBanner title={aboutUsData?.title} />
                )

            }
            <AboutDetail
                section_four_content={aboutUsData?.section_four_content}
                section_four_heading={aboutUsData?.section_four_heading}
                section_four_image={aboutUsData?.section_four_image}
                section_four_sub_heading={aboutUsData?.section_four_sub_heading}
                section_one_content={aboutUsData?.section_one_content}
                section_one_heading={aboutUsData?.section_one_heading}
                section_one_image={aboutUsData?.section_one_image}
                section_three_content={aboutUsData?.section_three_content}
                section_three_heading={aboutUsData?.section_three_heading}
                section_three_image={aboutUsData?.section_three_image}
                section_three_sub_heading={aboutUsData?.section_three_sub_heading}
                section_two_content={aboutUsData?.section_two_content}
                section_two_heading={aboutUsData?.section_two_heading}
                section_two_image_one={aboutUsData?.section_two_image_one}
                section_two_image_two={aboutUsData?.section_two_image_two}
            />
            <Features />
        </Fragment>
    )
}

export default AboutUs